(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("@duik/form-group"), require("@duik/use-open-state"), require("@duik/dropdown"), require("@duik/content-title"), require("@duik/datepicker"));else if (typeof define === 'function' && define.amd) define(["@duik/form-group", "@duik/use-open-state", "@duik/dropdown", "@duik/content-title", "@duik/datepicker"], factory);else {
    var a = typeof exports === 'object' ? factory(require("@duik/form-group"), require("@duik/use-open-state"), require("@duik/dropdown"), require("@duik/content-title"), require("@duik/datepicker")) : factory(root["@duik/form-group"], root["@duik/use-open-state"], root["@duik/dropdown"], root["@duik/content-title"], root["@duik/datepicker"]);

    for (var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
  }
})(this, function (__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__10__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
          return value[key];
        }.bind(null, key));
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 77);
      /******/
    }
    /************************************************************************/

    /******/
    ({
      /***/
      0:
      /***/
      function (module, exports) {
        module.exports = require("react");
        /***/
      },

      /***/
      1:
      /***/
      function (module, exports) {
        module.exports = require("classnames");
        /***/
      },

      /***/
      10:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__10__;
        /***/
      },

      /***/
      156:
      /***/
      function (module, exports) {
        // removed by extract-text-webpack-plugin
        module.exports = {
          "select-date": "select-date",
          "select-date-dropdown": "select-date-dropdown"
        };
        /***/
      },

      /***/
      18:
      /***/
      function (module, exports) {
        /***/
      },

      /***/
      3:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__3__;
        /***/
      },

      /***/
      4:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__4__;
        /***/
      },

      /***/
      5:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__5__;
        /***/
      },

      /***/
      53:
      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "a", function () {
          return defaultRenderValue;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

        var defaultRenderValue = function (value, isRange, placeholder) {
          if (!value) {
            return placeholder;
          }

          if (isRange) {
            var dateRange = value;

            if (!dateRange.to && !dateRange.from) {
              return placeholder;
            }

            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, dateRange.from && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("strong", null, dateRange.from.toLocaleDateString()) || placeholder, "\u00A0\u00A0\u2550\u00A0\u00A0", dateRange.to && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("strong", null, dateRange.to.toLocaleDateString()) || placeholder, " ");
          }

          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("strong", null, value.toLocaleDateString() || "-");
        };
        /***/

      },

      /***/
      77:
      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SelectDate", function () {
          return SelectDate;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _duik_datepicker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
        /* harmony import */


        var _duik_datepicker__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_duik_datepicker__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _duik_dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
        /* harmony import */


        var _duik_dropdown__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_duik_dropdown__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _duik_content_title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
        /* harmony import */


        var _duik_content_title__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_duik_content_title__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _duik_use_open_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
        /* harmony import */


        var _duik_use_open_state__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_duik_use_open_state__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _duik_form_group__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
        /* harmony import */


        var _duik_form_group__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_duik_form_group__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _styles_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(156);
        /* harmony import */


        var _styles_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _defaultRenders__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53);
        /* harmony import */


        var _types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18);
        /* harmony import */


        var _types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony reexport (unknown) */


        for (var __WEBPACK_IMPORT_KEY__ in _types__WEBPACK_IMPORTED_MODULE_9__) if (["SelectDate", "default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function (key) {
          __webpack_require__.d(__webpack_exports__, key, function () {
            return _types__WEBPACK_IMPORTED_MODULE_9__[key];
          });
        })(__WEBPACK_IMPORT_KEY__);

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};

          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        };

        var SelectDate = function (props) {
          var openControls = Object(_duik_use_open_state__WEBPACK_IMPORTED_MODULE_5__["useOpenState"])();

          var // Datepicker Props
          renderTitle = props.renderTitle,
              renderMonthName = props.renderMonthName,
              renderWeekdayShort = props.renderWeekdayShort,
              isRange = props.isRange,
              valueProp = props.value,
              onDateChangeProp = props.onDateChange,
              minDate = props.minDate,
              maxDate = props.maxDate,
              initialVisibleDate = props.initialVisibleDate,
              weekdayOffset = props.weekdayOffset,
              //other
          _a = props.placeholder,
              //other
          placeholder = _a === void 0 ? "Select Date" : _a,
              label = props.label,
              _b = props.renderValue,
              renderValue = _b === void 0 ? _defaultRenders__WEBPACK_IMPORTED_MODULE_8__[
          /* defaultRenderValue */
          "a"] : _b,
              noWrap = props.noWrap,
              // rest is dropdown props
          dropdownProps = __rest(props, ["renderTitle", "renderMonthName", "renderWeekdayShort", "isRange", "value", "onDateChange", "minDate", "maxDate", "initialVisibleDate", "weekdayOffset", "placeholder", "label", "renderValue", "noWrap"]);

          var _c = Object(_duik_datepicker__WEBPACK_IMPORTED_MODULE_2__["useDatepickerValue"])(valueProp, isRange, onDateChangeProp),
              setValue = _c.setValue,
              value = _c.value;

          var onDateChange = function (value) {
            setValue(value);

            if (!isRange) {
              openControls.handleClose();
            } else {
              if (value && value.to) {
                openControls.handleClose();
              }
            }
          };

          var datepickerProps = {
            renderTitle: renderTitle,
            renderMonthName: renderMonthName,
            renderWeekdayShort: renderWeekdayShort,
            isRange: isRange,
            value: value,
            onDateChange: onDateChange,
            minDate: minDate,
            maxDate: maxDate,
            initialVisibleDate: initialVisibleDate,
            weekdayOffset: weekdayOffset
          };
          var _d = dropdownProps.menuProps,
              menuProps = _d === void 0 ? {} : _d;

          var menuMergedProps = __assign(__assign({}, menuProps), {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a["select-date-dropdown"], menuProps.className)
          }); // __TODO fix typing


          var el = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, label && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_content_title__WEBPACK_IMPORTED_MODULE_4__["ContentTitle"], null, label), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_dropdown__WEBPACK_IMPORTED_MODULE_3__["Dropdown"], __assign({
            className: _styles_scss__WEBPACK_IMPORTED_MODULE_7___default.a["select-date"],
            openControls: openControls,
            buttonText: renderValue(value, isRange, placeholder),
            menuProps: menuMergedProps
          }, dropdownProps), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_datepicker__WEBPACK_IMPORTED_MODULE_2__["Datepicker"], __assign({}, datepickerProps))));
          return label && !noWrap ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_form_group__WEBPACK_IMPORTED_MODULE_6__["FormGroup"], null, el) : el;
        };

        SelectDate.displayName = "SelectDate";
        /***/
      },

      /***/
      8:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__8__;
        /***/
      }
      /******/

    })
  );
});